module.exports = __webpack_public_path__ + "img/astrobabe_hair.a7b83c34.jpg";